import React, { useState, useContext, useEffect } from "react";
import "./styles.css";
import { GlobalContext } from "../../context/GlobalContext";
import { ErrorHelper, handleSuccess, DotsLoader } from "../../components";
import { useTranslation } from "react-i18next";
import {
  CardElement,
  Elements,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

export default function CheckOut({ giveData }) {
  const getContextItems = useContext(GlobalContext);
  let {} = getContextItems;
  const stripePromise = loadStripe(
    "pk_test_51KhAFmIKFR1rw6VlcdmDv1YIVc4dlkeZnyRjzQiFHn7GCLxMHIsBRPrRywSCoSedRhVO4b5NaffoIxeYK9SqY9Hi00lBvvQHcg"
  );

  return (
    <Elements stripe={stripePromise}>
      <MyCheckoutForm giveData={giveData} />
    </Elements>
  );
}
const MyCheckoutForm = (props) => {
  const [isLoading, setLoading] = useState(false);
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmitForm = async (event) => {
    setLoading(true);
    event.preventDefault();
    if (!stripe || !elements) {
      return;
    }

    const cardElement = elements.getElement(CardElement);

    // Use your card Element with other Stripe.js APIs
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: cardElement,
    });

    if (error) {
      setLoading(false);
      elements.getElement("card").focus();
      ErrorHelper(error.message, true);
    } else {
      setLoading(false);
      props.giveData(paymentMethod);
      // handleSuccess("Cradit Card Approved", true);
    }
  };

  const CARD_OPTIONS = {
    iconStyle: "solid",
    style: {
      base: {
        iconColor: "#005494",
        color: "#212529",
        fontWeight: 500,
        fontSize: "16px",
        fontSmoothing: "antialiased",
        ":-webkit-autofill": {
          color: "#fce883",
        },
        "::placeholder": {
          color: "grey",
        },
      },
      invalid: {
        iconColor: "red",
        color: "red",
      },
    },
  };

  return (
    <form onSubmit={handleSubmitForm}>
      <div className="deliveryTotal mt-2">
        <CardElement options={CARD_OPTIONS} />
        <div className="mt-2">Enter Cradit Card Detail</div>
      </div>
      {isLoading ? (
        <DotsLoader isloading={isLoading} />
      ) : (
        <button
          class="btn-custom btn-light btnProductCheck"
          onClick={handleSubmitForm}
        >
          PAY NOW
        </button>
      )}
    </form>
  );
};
